import { httpClient } from '../http/httpClient'

export interface SupportRequestsChartResponse {
  total: number
  days: { date: string; count: number }[]
}

// os últimos 7 dias, numa requisição só
export async function getSupportRequestsChart() {
  const { data } = await httpClient.get<SupportRequestsChartResponse>(
    '/support-requests/stats/chart',
  )

  return data
}
